<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Logs Manutenção</h5>
                <hr>

                <TabView>
                    <TabPanel header="Logs">
                        <LogsManutencao />
                    </TabPanel>
                    <TabPanel header="Status Fila">                       
                        <StatusFila />
                    </TabPanel>
                </TabView>                
                
            </div>
        </div>
    </div>
</template>

<script>

import LogsManutencao from '@/components/pages/monitoramento/LogsManutencao.vue';
import StatusFila from '@/components/pages/monitoramento/StatusFila.vue';

export default {
    logsManutencaoService: null,
    data() {
        return {         
        }
    },
    methods: {},    
    created() {},
    components: {
        'LogsManutencao': LogsManutencao,
        'StatusFila': StatusFila
    }
}
</script>